// 将此代码放置在所有依赖加载之前（如顶部）
import { webcrypto } from 'crypto-browserify'

if (!globalThis.crypto) {
  globalThis.crypto = webcrypto
  // 如果特定方法缺失，可额外补充
  if (!globalThis.crypto.getRandomValues) {
    globalThis.crypto.getRandomValues = webcrypto.getRandomValues
  }
}
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import en from 'element-plus/es/locale/lang/en'
import i18n from '@/plugins/i18n'
// import './styles/balance.css'
import App from './App.vue'
import router from './router'
import pinia from './stores'
import { parseUrlTokenAndSave } from '@/utils/auth'
import { useAuthStore } from '@/stores/auth'
import directives from './directives' // 导入全局指令
import analytics from '@/utils/analytics' // 导入埋点SDK

import '@/styles/index.scss'
import '@/styles/hallucination-batch-confirm.css'
// 导入全局滚动条样式
import '@/assets/styles/global-scrollbar.scss'

// 在应用初始化时检查URL参数中的token
try {
  console.log('应用初始化时解析URL参数...');
  const urlHasToken = parseUrlTokenAndSave();
  if (urlHasToken) {
    console.log('main.js: 成功从URL解析并保存token');
  }
} catch (error) {
  console.error('main.js: URL参数解析失败:', error);
}

const app = createApp(App)

const savedLocale = i18n.global.locale.value

// 添加全局错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('全局错误:', err)
  console.error('错误信息:', info)
  console.error('组件实例:', vm)
  
  // 检查是否是401错误
  if (err.response && err.response.status === 401) {
    console.log('全局错误处理捕获到401错误，准备跳转登录页')
    
    // 防止重复跳转
    if (!window._lastRedirectToLogin || Date.now() - window._lastRedirectToLogin > 5000) {
      window._lastRedirectToLogin = Date.now()
      
      // 确保当前不在登录页
      if (router.currentRoute.value.path !== '/login' && router.currentRoute.value.path !== '/register' && router.currentRoute.value.path !== '/forgot-password' && router.currentRoute.value.path !== '/reset-password') {
        console.log('全局错误处理跳转到登录页')
        router.push('/login')
      }
    }
  }
  
  // 处理 TypeError: Cannot read properties of null
  if (err instanceof TypeError && err.message.includes('Cannot read properties of null')) {
    console.error('捕获到空值引用错误，尝试恢复:', err.message)
    // 不阻止应用运行，只记录错误
    return
  }
  
  // 处理组件更新错误
  if (info && info.includes('component update')) {
    console.error('组件更新错误，尝试恢复:', err)
    // 尝试刷新当前路由
    const currentPath = router.currentRoute.value.fullPath
    router.replace('/').then(() => {
      setTimeout(() => {
        router.replace(currentPath)
      }, 100)
    })
    return
  }
}

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 使用pinia作为状态管理
app.use(pinia)

// 注册路由
app.use(router)
app.use(i18n)

// 使用Element Plus组件库
app.use(ElementPlus, {
  locale: savedLocale === 'zh-CN' ? zhCn : en,
})

// 注册全局指令
app.use(directives)

// 将analytics SDK挂载到全局属性，供所有组件使用
app.config.globalProperties.$analytics = analytics
console.log('[Analytics] SDK已挂载到全局属性')

// 在应用挂载前初始化认证状态（先挂载 UI，避免登录页白屏等待 token 校验）
async function initializeApp() {
  app.mount('#app')
  console.log('应用挂载完成');

  try {
    console.log('开始初始化应用认证状态...');
    const authStore = useAuthStore();
    const isAuthenticated = await authStore.initAuth();
    console.log('认证状态初始化完成，是否已认证:', isAuthenticated);
  } catch (error) {
    console.error('应用认证初始化失败:', error);
  }
}

// 启动应用
initializeApp()
